function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import colors from '../../visid/colors';
import typeface from '../../visid/typeface';
import typography from '../../visid/typography';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1s164by-main",
  styles: "width:100%;label:main;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "pit38s",
  styles: "height:auto"
} : {
  name: "1hiclq0-main",
  styles: "height:auto;label:main;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "3yu6vl",
  styles: "font-size:50%;vertical-align:top"
} : {
  name: "34ddwj-main",
  styles: "font-size:50%;vertical-align:top;label:main;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var main = function main(el) {
  switch (el) {
    case 'hr':
      {
        return /*#__PURE__*/css("background-color:", colors.gray_500, ";border:0;height:0.1rem;margin:2.5rem 0;padding:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:main;"));
      }
    case 'sup':
      {
        return _ref3;
      }
    case 'code':
      {
        return /*#__PURE__*/css("background-color:", colors.gray_300, ";font-family:", typeface.typefaceMonospace, ";padding:0.2rem 0.3rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:main;"));
      }
    case 'dl':
      {
        return /*#__PURE__*/css("dt{font-weight:", typography.typographyFontWeightBold, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:main;"));
      }
    case 'img':
      {
        return _ref2;
      }
    case 'button':
      {
        return /*#__PURE__*/css("color:", colors.black, ";cursor:pointer;font-family:", typeface.typefaceBase, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:main;"));
      }
    case 'input':
      {
        return /*#__PURE__*/css("color:", colors.black, ";font-family:", typeface.typefaceBase, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:main;"));
      }
    case 'table':
    case 'legend':
      {
        return _ref;
      }
  }
};
export default main;